import Component from 'vue-class-component';

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { SearchFeaturedList } from '@skinsoft/ui';

import { SearchHeader } from '@skinsoft/search/src/search-header';
import { Routes } from '../../../router';

declare const ITEM_SORTING_ENTITY_FIELDS: any[];

@Component({
    components: {
        sSearchFeaturedList: SearchFeaturedList,
        sSearchHeader: SearchHeader,
    },
    template: require('./item-search-screen.html')
})
export class ItemSearchScreen extends ReactiveVue {

    public targetRouteName = Routes.EDIT_REPORT;

    private sortingEntityFields: any[] = [];

    public mounted() {
        this.sortingEntityFields = ITEM_SORTING_ENTITY_FIELDS;
    }

}